import { MapPin, Search, Users } from 'lucide-react'
import { Input } from '@/shared/components/ui/input'
import { Label } from '@/shared/components/ui/label'

type SearchFieldProps = {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  icon?: 'search' | 'map' | 'users'
  type?: string
  min?: number
  inputMode?: 'numeric' | 'decimal' | 'text'
  error?: string
}

export function SearchField({
  id,
  label,
  value,
  onChange,
  placeholder,
  icon,
  type = 'text',
  min,
  inputMode,
  error,
}: SearchFieldProps) {
  const Icon = icon === 'search' ? Search : icon === 'map' ? MapPin : icon === 'users' ? Users : null
  const errorId = error ? `${id}-error` : undefined
  return (
    // `flex h-full flex-col` + `mt-auto` sur le champ : la cellule s'étire à la hauteur
    // de la rangée (grid `align-items:stretch`) et l'input se cale en bas → tous les inputs
    // d'une rangée restent alignés même quand un label passe sur 2 lignes (i18n FR/EN).
    <div className="flex h-full min-w-0 flex-col">
      <Label htmlFor={id} className="mb-1.5">
        {label}
      </Label>
      <div className="relative mt-auto">
        {Icon ? (
          <Icon
            className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
            aria-hidden
          />
        ) : null}
        <Input
          id={id}
          type={type}
          min={min}
          inputMode={inputMode}
          value={value}
          placeholder={placeholder}
          aria-invalid={error ? true : undefined}
          aria-describedby={errorId}
          onChange={(e) => onChange(e.target.value)}
          className={Icon ? 'pl-9' : undefined}
        />
      </div>
      {error ? (
        <p id={errorId} role="alert" className="mt-1 text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  )
}
